document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-menu-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const menu = document.querySelector('[data-mobile-menu]');
      const open = menu && menu.toggleAttribute('data-open');
      button.setAttribute('aria-expanded', String(Boolean(open)));
    });
  });

  document.querySelectorAll('[data-qty]').forEach((group) => {
    const input = group.querySelector('input');
    group.querySelectorAll('button').forEach((button) => {
      button.addEventListener('click', () => {
        const delta = Number(button.dataset.delta || 0);
        input.value = Math.max(1, Number(input.value || 1) + delta);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });
});
